<template>
  <div class="d-flex flex-column">
    <div class="row toolbar-pf table-view-pf-toolbar">
      <div class="col-sm-12">
        <div class="toolbar-pf-actions">
          <div class="form-group toolbar-pf-filter">
            <form>
              <div class="input-group">
                <div class="input-group-btn">
                  <select v-model="filterForm.key" class="selectpicker filter-select">
                    <option v-for="filter in filters" :key="filter.key" :value="filter.key">{{ filter.text }}</option>
                  </select>
                </div>
                <input v-model="filterForm.value" type="text" class="form-control" placeholder="คำค้น..." autocomplete="off" name="aaa" required>
                <div class="input-group-btn">
                  <button class="btn btn-default" @click.prevent="addFilter">ค้นหา</button>
                </div>
              </div>
            </form>
          </div>

          <div class="toolbar-pf-action-right">
            <slot name="toolbar-button" />
          </div>
        </div>
        <div class="row toolbar-pf-results">
          <div class="col-sm-9">
            <div v-if="appliedFilters.length">
              <h5>พบ 0 จาก {{ data.length }} รายการ</h5>
              <p>ตัวกรอง:</p>
              <ul class="list-inline">
                <li v-for="(appliedFilter, index) in appliedFilters" :key="index">
                  <span class="label label-info">
                    {{ filters.find(filter => filter.key === appliedFilter.key).text }}: {{ appliedFilter.value }}
                    <a href="#" @click.prevent="deleteFilter(index)"><span class="fa fa-times" /></a>
                  </span>
                </li>
              </ul>
              <p><a href="#" @click="deleteAllFilter">ล้างเงื่อนไขทั้งหมด</a></p>
            </div>
            <h5 v-else>ทั้งหมด {{ data.length }} รายการ</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-fill">
      <div class="table-responsive">
        <table id="table" class="table table-striped table-bordered table-hover datatable">
          <thead>
            <slot name="thead" />
          </thead>
        </table>

        <div v-if="!data.length" class="blank-slate-pf table-view-pf-empty flex-fill">
          <div class="blank-slate-pf-icon">
            <span class="fa fa-inbox" />
          </div>
          <h1>ไม่พบข้อมูล{{ name }}</h1>
          <div v-if="appliedFilters.length">
            <p>ไม่มี{{ name }}ใดตรงกับเงื่อนไขที่ท่านกำลังค้นหา</p>
            <p class="text-muted"><em>ศึกษาวิธีการใช้ระบบเพิ่มเติมได้ใน <a href="#">คู่มือการใช้งาน</a></em></p>
            <div class="blank-slate-pf-main-action">
              <a href="/" class="btn btn-default btn-lg">ล้างเงื่อนไขการค้นหา</a>
            </div>
          </div>
          <div v-else>
            <p>ท่านสามารถเพิ่มรายวิชาใหม่เข้าระบบโดยคลิกที่ปุ่ม "สร้าง{{ name }}" ด้านล่าง</p>
            <p class="text-muted"><em>ศึกษาวิธีการใช้ระบบเพิ่มเติมได้ใน <a href="#">คู่มือการใช้งาน</a></em></p>
            <div class="blank-slate-pf-main-action">
              <router-link class="btn btn-primary btn-lg" :to="createLink">สร้าง{{ name }}</router-link>
            </div>
          </div>
        </div>

        <form id="page" class="content-view-pf-pagination table-view-pf-pagination clearfix">
          <div class="form-group">
            <span>จำนวนต่อหน้า</span>
            <select class="selectpicker pagination-pf-pagesize" style="display: none;">
              <option value="6">6</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="30" selected>30</option>
              <option value="50">50</option>
              <option value="70">70</option>
            </select>
            <span>รายการ</span>
          </div>
          <div class="form-group">
            <span>กำลังแสดง <span class="pagination-pf-items-current">0</span> จาก <span class="pagination-pf-items-total">0</span></span>
            <ul class="pagination pagination-pf-back">
              <li class="disabled"><a href="#" title="First Page"><span class="i fa fa-angle-double-left" /></a></li>
              <li class="disabled"><a href="#" title="Previous Page"><span class="i fa fa-angle-left" /></a></li>
            </ul>
            <input class="pagination-pf-page" type="text" value="1">
            <span>จาก <span class="pagination-pf-pages">0</span></span>
            <ul class="pagination pagination-pf-forward">
              <li><a href="#" title="Next Page"><span class="i fa fa-angle-right" /></a></li>
              <li><a href="#" title="Last Page"><span class="i fa fa-angle-double-right" /></a></li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import jquery from 'jquery'
import 'datatables.net'

export default {
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    name: { type: String, required: true },
    createLink: { type: String, required: true },
    filters: { type: Array, required: true }
  },
  data () {
    return {
      appliedFilters: [],
      filterForm: {
        key: '',
        value: ''
      }
    }
  },
  watch: {
    data () {
      this.initializeTable()
    }
  },
  created () {
    // Set initial selector value of "Filter Form"
    this.filterForm.key = this.filters[0].key
    this.initializeTable()
  },
  mounted () {
    this.initializeTable()
  },
  methods: {
    initializeTable () {
      jquery('.datatable').DataTable({
        columns: this.columns,
        data: this.data,
        dom: 't',
        language: {
          zeroRecords: 'ไม่มีข้อมูล'
        },
        order: [[ 0, 'asc' ]],
        pfConfig: {
          paginationSelector: '#page',
          pageSize: 30
        }
      })
    },
    addFilter () {
      this.appliedFilters.push({
        key: this.filterForm.key,
        value: this.filterForm.value
      })
      this.resetFilterForm()
    },
    deleteFilter (index) {
      this.appliedFilters.splice(index, 1)
    },
    deleteAllFilter () {
      this.appliedFilters = []
    },
    resetFilterForm () {
      this.filterForm.value = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/shared/DataTable.vue